import React from 'react';
import WeatherComponentContainer from './WeatherComponent/WeatherComponentContainer';
import ConsumptionBreakdownContainer from './ConsumptionBreakdownComponent/ConsumptionBreakdownContainer';
import BillProjectionContainer from './BillProjectionComponent/BillProjectionContainer';
import UsageSummaryContainer from './UsageSummaryComponent/UsageSummaryContainer';
import InsightsContainer from './InsightsComponent/InsightsContainer';
import UsageHistoryContainer from './UsageHistoryComponent/UsageHistoryContainer';
import SmartRecommendationContainer from './SmartRecoComponent/SmartRecommendationContainer';
import Environment from './EnvironmentComponent/Environment';
import FooterMain from "../../standalone/common/Footer/FooterMain";
import { connect } from 'react-redux';
import { trackEvent } from '../../../helpers/analyticsHelper';
import { PAGE_EVENT_NAMES , FUEL_TYPE } from '../../../constants/common';
import { withLastLocation } from "react-router-last-location";
import { setPageTitle } from '../../../helpers/helper';

class HomePageMain extends React.Component {
  componentDidMount(){
    setPageTitle("HOME_PAGE.TITLE", this.props.translations.data, this.props.configs.data)
    trackEvent(this.props.userObj.details.uuid , PAGE_EVENT_NAMES.DASHBOARD , {
      viewed: true ,
      dashboardView: FUEL_TYPE.ELECTRIC,
      shown: 'Itemization, Usage Summary, Projected Bill, Usage History , Insight Feed , EnvImpact , WeatherImpact'
    }, this.props);
  }
  render(){
    let billProjectionEnabled = this.props.configs.data["billProjectionWidget.enable"] === "true";
    return(
      <>
      <div className = "home-page-main">
        <div className="component-wrapper">
          <WeatherComponentContainer/>
          <div className="row-wrapper">
            <ConsumptionBreakdownContainer />
            <div className="column-wrapper">
              <UsageSummaryContainer />
              {billProjectionEnabled ?  <BillProjectionContainer /> :  <Environment halfScreen={true}/> }
            </div>
          </div>
          <div className="row-wrapper">
            <div className="column-wrapper">
              <UsageHistoryContainer />
            </div>
            <InsightsContainer />
          </div>
          <div className="row-wrapper">
            {this.props.configs.data["smartRecommendationWidget.enable"] === "true" ?
            <SmartRecommendationContainer/> : '' }
          </div>
          <div className="row-wrapper">
          {billProjectionEnabled ? <Environment/> : '' }
          </div>
        </div>
      </div>
      {(this.props.configs && this.props.configs.data && this.props.configs.data["DASHBOARD.HOME_PAGE.FOOTER.SHOW"]) === "true" ?
          (<FooterMain configs={this.props.configs} translations={this.props.translations} />)
          : ''
      }
    </>
    )
  }
}

const mapStateToProps = state => {
  return {
    configs: state.configs,
    translations: state.translationsData,
    userObj: state.userObject,
    queryParams: state.queryParams
  }
}

export default withLastLocation(connect(mapStateToProps)(HomePageMain));
